import { createSlice } from '@reduxjs/toolkit';
import { getHospitalTemplateApi } from '../../../rtk-apis/clinics/getReportTemplate';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const getReportTemplateApiSlice = createSlice({
  name: 'getReportTemplate',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getHospitalTemplateApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getHospitalTemplateApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(getHospitalTemplateApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getReportTemplateApiSlice.reducer;
export const { clearState } = getReportTemplateApiSlice.actions;
